module.exports = __webpack_public_path__ + "img/icon_register.0993efe4.png";